import { createVNode as n, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DocumentManageFilledStandard.js";
import l from "../components/PfIcon.js";
const e = (t, a) => {
  const r = {
    ...t,
    ...a.attrs
  };
  return n(l, o(r, {
    icon: d
  }), null);
};
e.displayName = "DocumentManageFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
